import styles from "./map-view.module.css";

export default function MapViewLoading() {
  return (
    <div className={styles.customMapContainer}>
      <div className={`${styles.mapContainer} ${styles.isLoading}`}></div>
    </div>
  );
}
